import React from 'react'
import * as Displays from 'support/displays'
import { WhenModelValue } from '@morningtrain/react-resources'
import SalaryBadge from 'pages/app/hr/salary/SalaryBadge'
import { Translation, Translator } from '@morningtrain/react-translations'

export default function Subtitle () {
  return (
    <Translator namespace='hr.salary.badges'>
      <Displays.Text name='primary_department_name' />
      <WhenModelValue name='user.is_new_in_department' condition>
        <SalaryBadge>
          <Translation name='new_in_department' />
        </SalaryBadge>
      </WhenModelValue>
      <WhenModelValue name='user.was_hired_in_period' condition>
        <SalaryBadge>
          <Translation name='was_hired_in_period' />
        </SalaryBadge>
      </WhenModelValue>
      <WhenModelValue name='user.has_been_lent_out' condition>
        <SalaryBadge>
          <Translation name='has_been_lent_out' />
        </SalaryBadge>
      </WhenModelValue>
    </Translator>
  )
}
